import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import dom from '../../wrapper/DomWrapper';
import CookieAnalyticsManager from '../CookieBannerManager/CookieAnalyticsManager';
import uuid from '../../helpers/uuid';

import {
  getScreenResolution,
  postAnalyticApiRequest,
  postNavigatorRequest,
} from './utils';
import { LOCAL, LEAVE_WEBSITE_ACTION, ENTER_WEBSITE_ACTION } from './constants';

class PlatformAnalytics {
  constructor(projectId, isGdprEnabled) {
    this.analyticsManager = new CookieAnalyticsManager();
    this.payload = {
      transactionId: uuid(),
      action: ENTER_WEBSITE_ACTION,
      cookie: this.analyticsManager.getCookies(),
      projectId,
      screenResolution: getScreenResolution(),
      path: dom.window.location.pathname,
    };
    this.isGdprEnabled = isGdprEnabled;
  }

  init = async () => {
    try {
      const response = await postAnalyticApiRequest(this.payload);
      this.handleAnalytic(response);
    } catch (error) {
      console.warn(error);
    }
  }

  handleUnload = async () => {
    const initialValue = await this.analyticsManager.getInitialValue();
    const isAnalyticsEnabled = !this.isGdprEnabled || !!initialValue;

    if (!isAnalyticsEnabled) return;

    postNavigatorRequest({
      ...this.payload,
      action: LEAVE_WEBSITE_ACTION,
    });
  }

  getAnalyticsData = async (response) => {
    try {
      const data = await response.json();
      return data;
    } catch (error) {
      return {};
    }
  }

  handleAnalytic = async (response) => {
    if (!get(response, ['ok'], false)) return;

    dom.on(dom.window, 'unload', this.handleUnload);
    // On first response backend sends platform analytics keys
    // Futher responses are empty
    // Frontend side sends this keys in the body request
    const data = await this.getAnalyticsData(response);

    if (isEmpty(data)) return;

    Object.keys(data).forEach((key) => {
      const {
        value, maxAge, domain, ...options
      } = data[key];
      const maxAgeOptions = maxAge ? { maxAge: maxAge.toString() } : {};
      const domainOptions = domain ? { domain: domain.indexOf(LOCAL) >= 0 ? LOCAL : domain } : {};
      const analyticsOptions = {
        ...options,
        ...maxAgeOptions,
        ...domainOptions,
      };

      this.analyticsManager.setCookies(key, value, analyticsOptions);
    });
  };
}

export default PlatformAnalytics;
